import React from 'react';
import { useTranslate } from '@hooks';
import { InputClipboard, Text } from '@dotone/react-ui-core';

const Section = (props) => <div className="mb-3" {...props} />;

const UrlBlock = ({ title, subtitle, value }) => (
  <>
    {title && <h6 className="text-dark-light">{title}</h6>}
    <Text>{subtitle}</Text>
    <InputClipboard value={value} className="mb-3" />
  </>
);

const DocsS2sPostback = () => {
  const { t, tHtml } = useTranslate('docs', 's2sPostback');

  return (
    <>
      <Section>
        <h6 className="text-dark-light">{t('requestUrl')}</h6>
        <InputClipboard
          value="https://vbtrax.com/track/postback/conversions/8/global"
          className="mb-3"
        />
      </Section>
      <Section>
        <div>{tHtml('params')}</div>
      </Section>
      <Section>
        <UrlBlock
          title={t('sampleCps.title')}
          subtitle={tHtml('sampleCps.withOrderTotal')}
          value="https://vbtrax.com/track/postback/conversions/8/global?server_subid=9142ef919dd612b6add8e625ee212f2b&order_total=100&step=sale"
        />
        <UrlBlock
          subtitle={tHtml('sampleCps.withRevenue')}
          value="https://vbtrax.com/track/postback/conversions/8/global?server_subid=9142ef919dd612b6add8e625ee212f2b&revenue=10&step=sale"
        />
        <UrlBlock
          subtitle={tHtml('sampleCps.withOrderTotalAndRevenue')}
          value="https://vbtrax.com/track/postback/conversions/8/global?server_subid=9142ef919dd612b6add8e625ee212f2b&order_total=100&revenue=10&step=sale"
        />
      </Section>
      <Section>
        <UrlBlock
          title={t('sampleCpl.title')}
          value="https://vbtrax.com/track/postback/conversions/8/global?server_subid=9142ef919dd612b6add8e625ee212f2b&step=sale&adv_uniq_id=5661468"
        />
      </Section>
      <Section>
        <div>{tHtml('response')}</div>
      </Section>
    </>
  );
};

export default DocsS2sPostback;
